import { AbstractScriptLoader } from './AbstractScriptLoader';

class PsoOrderCompletionScriptLoader extends AbstractScriptLoader {
  name: string = 'PSO_ORDER_COMPLETION';
  identifier: string = 'techem';
  env: string = 'https://api.pso-empfehlen.net/';
  product: string = 'techem_direct';

  isLoaded(): boolean {
    return !!(window as any)._pfe;
  }

  load(trackingId?: string): Promise<boolean> {
    return new Promise((): void => {
      throw new Error('Use loadAfterErmitData instead.');
    });
  }

  loadAfterEmitData() {
    const env = this.env.replace(/\/$/, '');

    let script: HTMLScriptElement = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `${env}/api/v1/${this.identifier}/tracking/abschluss`;

    script.setAttribute('data-cookieconsent', 'marketing');

    document.body.appendChild(script);
  }

  init(initNeeded: boolean, trackingId?: string): Promise<boolean> {
    return Promise.resolve(true);
  }

  emitDataById(orderId: string): void {
    let anyWindow = window as any;
    anyWindow._pfe = anyWindow._pfe || [];

    anyWindow._pfe.push(['nummer', orderId]);
    anyWindow._pfe.push(['produkt', this.product]);
  }
}

export const PsoOrderCompletionTracker = new PsoOrderCompletionScriptLoader();
